import React from 'react';

import ItemViewTop from "../../../../../layout/top/item-view-top/item-view-top";
import ErrorBoundary from "../../../../error-boundary";
import FieldManagementFormCFV1 from "../../../../fields3/render/management-form-cf-v1";
import FieldProto from '../../../../fields3/proto/field-proto';
import ApiCustomFields from "../../../../gd/api/custom-fields";
import {SessionCustomField} from "../../../../gd-model/custom-field/gd-custom-field";


type Props = {
    field           : FieldProto
    customField     : SessionCustomField
    onCloseClick    : callback,
    callback?       : callback
}

// const debug = "ModalCustomField_EditFieldV3"
const debug = false

export default class ModalCustomField_EditFieldV3 extends React.Component<Props> {

    onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation();
        e.preventDefault();
    }

    onSubmit = async (field: FieldProto) => {

        debug && console.log(debug, "onSubmit()", field)

        const response : any = await ApiCustomFields.update(this.props.customField.id, {
            name        : field.label,
            params      : field.fieldParams,
            access      : field.fieldAccess
        }).promise()

        gd.modal.hide();

        this.props.callback && this.props.callback()

        return
    }



    render() {

        debug && console.log(debug,"render() field=", this.props.field)


        const topLeftContent = <div className="ui5-txt-not-important-small">Edit custom field</div>

        return (
            <div className="v4-container placement-middle ui5-iv view-custom-field" style={{width: 840}} onClick={this.onClick}>
                <ItemViewTop leftContent={topLeftContent} onCloseClick={this.props.onCloseClick}/>

                <ErrorBoundary>

                    <FieldManagementFormCFV1 field      = {this.props.field}
                                             onSubmit   = {this.onSubmit} />

                </ErrorBoundary>
            </div>
        )
    }
}
